export default function Footer() {
  return (
    <footer className="bg-black px-6 py-16">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 grid gap-12 md:grid-cols-3">
          {/* Brand */}
          <div>
            <h3 className="mb-4 font-serif text-3xl font-light text-white">
              <span className="italic">Clique</span>
            </h3>
            <p className="text-sm leading-relaxed text-gray-400">
              Vancouver's Most Exclusive Network.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-4 text-sm font-medium uppercase tracking-widest text-gray-500">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="#benefits" 
                  className="text-sm text-gray-400 transition-colors hover:text-amber-400 cursor-pointer"
                >
                  Member Benefits
                </a>
              </li>
              <li>
                <a 
                  href="#application" 
                  className="text-sm text-gray-400 transition-colors hover:text-amber-400 cursor-pointer"
                >
                  Apply Now
                </a>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const eventsSection = document.querySelector('section:has(#application)');
                    if (eventsSection) {
                      eventsSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="text-sm text-gray-400 transition-colors hover:text-amber-400 cursor-pointer"
                >
                  Upcoming Events
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-4 text-sm font-medium uppercase tracking-widest text-gray-500">
              Connect
            </h4>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/clique.yvr?igsh=MTF6M212c3R5ajh6OQ%3D%3D&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center border border-gray-700 text-gray-400 transition-all hover:border-amber-400 hover:text-amber-400 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-500">
          <p>&copy; 2026 Clique. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
